import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dialog, FlatButton } from 'material-ui';

import { ifitBlack, ifitBlack54, ifitBlue } from '../../theme/colors';

class Modal extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    content: PropTypes.string,
    primaryActionLabel: PropTypes.string,
    handlePrimaryActionClick: PropTypes.func,
    secondaryActionLabel: PropTypes.string,
    handleSecondaryActionClick: PropTypes.func,
    openDefault: PropTypes.bool,
    isOpen: PropTypes.bool
  };

  constructor(props) {
    super(props);

    this.state = { isOpen: false };
  }

  componentDidMount() {
    if (this.props.openDefault) {
      this.setState({ isOpen: this.props.openDefault });
    }
  }

  handleOpen = () => {
    this.setState({ isOpen: true } );
  };

  handleClose = () => {
    this.setState({ isOpen: false } );
  };

  static defaultProps = {
    primaryActionLabel: 'Cancel',
    secondaryActionLabel: 'Ok'
  }

  customStyles = {
    modal: {
      width: '74.6%',
      maxWidth: 'none'
    },
    title: {
      color: ifitBlack,
      fontFamily: 'proxima-nova',
      fontWeight: 600
    },
    content: {
      color: ifitBlack54,
      fontFamily: 'proxima-nova',
      lineHeight: 1.5
    },
    actionLabel: {
      color: ifitBlue,
      fontFamily: 'proxima-nova',
      fontWeight: 600,
      letterSpacing: '0.05rem'
    }
  };

  render() {
    const {
      title,
      content,
      primaryActionLabel,
      handlePrimaryActionClick,
      secondaryActionLabel,
      handleSecondaryActionClick,
      isOpen
    } = this.props;

    const actions = [
      <FlatButton
        label={ primaryActionLabel }
        labelStyle={ this.customStyles.actionLabel }
        primary={ true }
        onClick={ handlePrimaryActionClick }
        key="primary"
      />,
      <FlatButton
        label={ secondaryActionLabel }
        labelStyle={ this.customStyles.actionLabel }
        primary={ true }
        key="secondary"
        onClick={ handleSecondaryActionClick || this.handleClose }
      />
    ];

    return (
      <div className="modal">
        <Dialog
          title={ title }
          titleStyle={ this.customStyles.title }
          bodyStyle={ this.customStyles.content }
          actions={ actions }
          modal={ true }
          contentStyle={ this.customStyles.modal }
          open={ isOpen || this.state.isOpen }
        >
          { content }
        </Dialog>
      </div>
    );
  }
}

export default Modal;
